'use client';
import { motion } from 'framer-motion';
import image from '../../Assets/image_1.png';
import * as S from './Solution.style';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0 },
};

export const Solution = () => {
  const benefits = [
    {
      title: 'Gestão de pátio:',
      text: 'Controle de agendamento, docas e movimentação interna.',
    },
    {
      title: 'Dashboards:',
      text: 'Dados em tempo real para decisões rápidas e precisas.',
    },
    {
      title: 'App de vistoria:',
      text: 'Simplifique a inspeção de veículos.',
    },
    {
      title: 'Redução de custos:',
      text: 'Otimize processos e aumente a eficiência operacional.',
    },
  ];

  return (
    <S.Wrapper id="Solution">
      <motion.img
        src={image}
        alt="mockup"
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
        className='hidden md:block w-full max-w-[70%] lg:-ml-8 xl:w-[50%] 2xl:w-[30%] xl:h-auto'
      />

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        className='xl:w-[50%]'
      >
        <S.Title as={motion.h1} variants={item}>
          A SOLUÇÃO BINDTRACK
        </S.Title>

        <S.SubText as={motion.p} variants={item}>
          A BindTrack oferece ferramentas de gestão de pátio (YMS), automação de processos e integração com sistemas corporativos para transformar sua operação.
        </S.SubText>

        <S.Text as={motion.ul}>
          {benefits.map((benefit, index) => (
            <motion.li key={index} variants={item} className="mb-2">
              <span className="font-bold">{benefit.title} </span>
              {benefit.text}
            </motion.li>
          ))}
        </S.Text>

        <S.Btn
          as={motion.button}
          variants={item}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          CONHEÇA MAIS BENEFÍCIOS
        </S.Btn>
      </motion.div>
    </S.Wrapper>
  );
};
